/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

/**
 * Space tab association (null if none)
 */
export type SpaceTab = (typeof SpaceTab)[keyof typeof SpaceTab];

export const SpaceTab = {
  AUDIO: 'audio',
  CONTROL: 'control',
  NETWORK: 'network',
  VIDEO: 'video',
  FLOORPLAN: 'floorplan',
} as const;
